export const Marquee = ({ items }: { items: string[] }) => {
  const row = items.map((i) => i.toUpperCase()).join("  ✦  ") + "  ✦  ";
  return (
    <div className="marquee" data-testid="marquee" aria-hidden="true">
      <div className="marquee-track">
        <span>{row}</span>
        <span>{row}</span>
      </div>
    </div>
  );
};
